import bowl from '../assets/art/bowl_ar 1.png';
import funnel from '../assets/art/funnel_ar 1.png';
import glasses from '../assets/art/glasses_ar 1.png';
import highHeels from '../assets/art/high heels_ar 1.png';
import mirror from '../assets/art/mirror_ar 1.png';
import umbrella from '../assets/art/umbrella_ar 1.png';

export const LIST = {
	default: [
		{
			src: bowl, x: undefined, y: 114, width: 400, height: 400,
		},
		{
			src: funnel, x: undefined, y: 224, width: 400, height: 400,
		},
		{
			src: glasses, x: undefined, y: 334, width: 400, height: 400,
		},
	],
	chindogu: [
		{
			src: highHeels, x: undefined, y: 224, width: 400, height: 400,
		},
		{
			src: mirror, x: undefined, y: 114, width: 400, height: 400,
		},
		{
			src: umbrella, x: undefined, y: 224, width: 400, height: 400,
		},
		{
			src: bowl, x: undefined, y: 114, width: 400, height: 400,
		},
		{
			src: funnel, x: undefined, y: 224, width: 400, height: 400,
		},
		{
			src: glasses, x: undefined, y: 334, width: 400, height: 400,
		},
	],
	jugaad: [
		{
			src: bowl, x: undefined, y: 114, width: 400, height: 400,
		},
		{
			src: funnel, x: undefined, y: 224, width: 400, height: 400,
		},
		{
			src: glasses, x: undefined, y: 334, width: 400, height: 400,
		},
		{
			src: highHeels, x: undefined, y: 224, width: 400, height: 400,
		},
		{
			src: mirror, x: undefined, y: 114, width: 400, height: 400,
		},
		{
			src: umbrella, x: undefined, y: 224, width: 400, height: 400,
		},
	],
};

export default LIST;
